<template>
    <BreadCrumb PageTitle="Ajout d'un arrièré" />
    <ListeArrires/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeArrires from "../../components/Arrires/ListeArrieres.vue";

  
    export default defineComponent({
      name: "ListeTarifAnnuelPage",
      components: {
        BreadCrumb,
        ListeArrires,
      },
    });
  </script>